import axiosPost from '../axiosPost';

export const aseguradoraDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "AseguradoraDel",
        "params": {
            "aseguradoraId": id
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}